import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Question } from '../interfaces/question';
import { CustomQuestionCounters } from '../interfaces/custom-question-counters';
import { AddCustomQuestions } from '../interfaces/add-custom-questions';
import { EditCustomQuestions } from '../interfaces/edit-custom-questions';
import { AnswerQuestion } from '../interfaces/tryout_interface/answer-question';
import { PreSetQuestion  } from '../interfaces/pre-set-question';
import { StandardQuestionList } from '../interfaces/standard-question-list';
import { HttpService } from './http.service';

@Injectable()
export class QuestionServiceService {

  private _url = '/api/ClubProgramQuestion';

  constructor(
    private http: HttpClient,
    private hs: HttpService,
  ) { }

  getCustomQuestionCounts(clubProgramID: string | number) {
    return this.http.get<CustomQuestionCounters>(this._url + '/custom-questions-count/' + clubProgramID);
  }

  getQuestions(clubProgramID: string | number, status: string) {
    // 0=>All, 1=>Required 2=>Not Required
    return this.http.get<Question>(this._url + '/get-clubprogramquestion/' + clubProgramID + '/' + status);
  }

  getCustomQuestionDetails(questionID: number) {
    return this.http.get<Question>(this._url + '/get-clubprogramquestiondetail/' + questionID);
  }

  deleteMultipleQuestionsByIDs(clubProgramQuestionsIDs: string) {
    return this.http.delete(this._url + '/delete-multiple-questions/' + clubProgramQuestionsIDs);
  }

  deleteSingleQuestionByID(questionId: any): any {
    return this.http.delete(this._url + '/delete-single-question/' + questionId);
  }

  // Save short text, Long Text, Single Choice, Multiple Choice, Dropdown.
  addQuestion(addCustomQuestions: AddCustomQuestions) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/addnewquestion', addCustomQuestions, httpOptions);
  }

  // Update question.  
  updateQuestion(editCustomQuestions: EditCustomQuestions) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/updatecustomquestion', editCustomQuestions, httpOptions);
  }

  updateAnswer(answerQuestion: AnswerQuestion) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.hs.post(this._url + '/addQuestionAnswersWithOptions/', answerQuestion, httpOptions);
  }
  
  getSetQuestions(clubProgramID: string, status: string | number, userID:string) {
    return this.http.get<Question>(this._url + '/get-clubuserprogramquestionanswer/' + clubProgramID + '/' + status + '/' + userID);
  }
  
  getpreSetQuestions(clubProgramID: string): Observable<PreSetQuestion[]> {
    return this.http.get<PreSetQuestion[]>(this._url + '/get-clubprogrampresetquestion/' + clubProgramID);
  }

  postStandardQuestions(standardQuestionList: StandardQuestionList) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/addstandardpresetquestions/', standardQuestionList, httpOptions);
  }
  
  updateUserCustomAnswers(QuesstionList) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.hs.post(this._url + '/update-user-custom-answers/', QuesstionList, httpOptions);
  }

  updateQuestionsOrder(clubProgramID, newOrder) {
    return this.hs.post(this._url + `/update-clubprogram-question-order/${clubProgramID}`, newOrder);
  }

  /**
   * Get user act scores.
   * 
   * @param memberID
   */
   getUserActScores(memberID: string): Observable<any> {
    //const _jsonURL = 'assets/mockup-data/QuestionAnswer.json';
    // return this.http.get<Questions[]>(_jsonURL);
    return this.http.get<any>('/api/ClubParent/getUserACTScores/' + memberID);
  }

  getListOfCities(stateID: number) {
    return this.hs.get('/api/ClubParent/getListOfCities/' + stateID);
  }

  getListOfSchools(stateID: number, city: string) {
    return this.hs.get('/api/ClubParent/getListOfSchools/' + stateID + '/' + city);
  }

  /**
   * Get questions with available answers.
   * 
   * @param programID
   * @param memberID
   */
   getQuestionList(programID: string, memberID: string): Observable<any[]> {
    return this.http.get<any[]>('/api/ClubParent/getListOfQuestionsAndAnswers/' + programID + '/' + memberID + '?showAll=1');
  }

  /**
   * Save answers.
   * 
   * @param answer
   */
   addQuestionAnswer(answer: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post('/api/ClubParent/addQuestionAnswer/', answer, httpOptions);
  }

  updateAgreement(clubprogramquestionID, status) {
    return this.http.post<any>(this._url + '/update-agreement/' + clubprogramquestionID, { status });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/question-service.service.ts